import { VoucherCode } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, useDialogAction } from '@mews/framework';
import { Dialog } from '@optimus-web/core';
import { useDeleteVoucherCodes } from '../../../../../queries';

interface DeletePropertiesWrapperProps {
    voucherCodes: VoucherCode[];
    renderButtonComponent: (onClick: () => void) => JSX.Element;
    onSuccess?: () => void;
}

export const DeleteVoucherCodesWrapper = ({
    voucherCodes,
    renderButtonComponent,
    onSuccess,
}: DeletePropertiesWrapperProps) => {
    const deleteVoucherCodesMutation = useDeleteVoucherCodes({ selectedVoucherCodes: voucherCodes });

    const deleteVoucherCodes = async () => {
        await deleteVoucherCodesMutation.mutateAsync(
            {
                voucherCodeIds: voucherCodes.map((voucherCode) => voucherCode.id),
            },
            {
                onSuccess,
            }
        );
    };

    const deleteAction = useDialogAction(deleteVoucherCodes);

    return (
        <>
            {renderButtonComponent(deleteAction.handlers.handleOpen)}
            {deleteAction.states.isDialogOpened ? (
                <Dialog
                    title={
                        <LocalizedText
                            textKey={TextKey.VoucherCodeDeleteConfirmationTitle}
                            substitutes={{ count: voucherCodes.length, name: voucherCodes[0]?.value }}
                        />
                    }
                    actions={[
                        {
                            children: <LocalizedText textKey={TextKey.Cancel} />,
                            onClick: deleteAction.handlers.handleCancel,
                            variant: 'tertiary',
                            size: 'medium',
                            type: 'button',
                        },
                        {
                            children: <LocalizedText textKey={TextKey.Delete} />,
                            onClick: deleteAction.handlers.handleConfirm,
                            variant: 'destructive',
                            size: 'medium',
                            type: 'submit',
                        },
                    ]}
                    active
                    loading={deleteAction.states.isProcessing}
                    onClose={deleteAction.handlers.handleCancel}
                >
                    <LocalizedText
                        textKey={TextKey.VoucherCodeDeleteConfirmationContent}
                        substitutes={{ count: voucherCodes.length }}
                    />
                </Dialog>
            ) : null}
        </>
    );
};
